export const PAGE_TITLE = 'Fidelity FundsNetwork';
export const LEGAL_FOOTER_COPYRIGHT = `© 1998-${new Date().getFullYear()} FMR LLC. All rights reserved.`;
export const LEGAL_FOOTER_USER_REFERENCE =
  'This is for persons in the U.S. only.';

/**
 * All related: deployUrl in angular.json, build options assets in angular.json,
 * production configuration assets in angular.json,
 * ASSETS_BASE_PATH in NextGenConstants.ts, proxies in karma.conf.js,
 * favicon url in index.html
 */
export const ASSETS_BASE_PATH = '/public/assets';

/**
 * Public Angular routes.
 * NOTE: Changes to these values alone is not enough. Make sure
 * to search through the app for instances where individual path segments
 * are hardcoded. Specifically all '*.routes.ts' files.
 */
export const PUBLIC_BASE_PATH = '/public/auth';
export const PUBLIC_LOGIN_PATH = `${PUBLIC_BASE_PATH}/login`;
export const PUBLIC_LOGOUT_PATH = `${PUBLIC_BASE_PATH}/logout`;
export const PUBLIC_LOGOUT_SESSION_PATH = `${PUBLIC_LOGOUT_PATH}/session`;
export const PUBLIC_LOGOUT_BADIP_PATH = `${PUBLIC_LOGOUT_PATH}/badip`;
export const PUBLIC_ACCESS_PATH = `${PUBLIC_BASE_PATH}/access`;
export const PUBLIC_ERROR_PATH = `${PUBLIC_BASE_PATH}/error`;
export const LOGOUT_REASONS = ['badip', 'session'] as const;
export const LOGOUT = 'logout' as const;
export const PUBLIC_CONTACT_PATH = `${PUBLIC_BASE_PATH}/contact`;
export const PUBLIC_USER_AGREEMENT_PATH = `${PUBLIC_BASE_PATH}/userAgreement`;

// Funds paths
export const FUNDS_BASE_PATH = '/funds';
export const FUNDS_REPORTING_BASE_PATH = `${FUNDS_BASE_PATH}/reporting`;
export const FUNDS_FIRM_PATH = `${FUNDS_BASE_PATH}/auth/selectFirm`;
export const FUNDS_AGREEMENT_PATH = `${FUNDS_BASE_PATH}/auth/userAgreement`;

// Fundsservices paths
export const FUNDSSERVICES_BASE_PATH = '/fundsservices';
export const FUNDSSERVICES_REPORTING_BASE_PATH = `${FUNDSSERVICES_BASE_PATH}/reporting`;
export const FUNDSSERVICES_SECURITY_BASE_PATH = `${FUNDSSERVICES_BASE_PATH}/security`;

// Core & Common
export const CC_APP_ID = 'FUNDSNETWORK-LOGIN-SDK';
export const CC_APP_REALM = 'FNW';
export const SYSTEM_ERROR_PAGE_VALUE = 'System error page';
export const CCL_EVENT_EMITTER = 'CCLEventEmitter';

// Ecaap endpoints
export const ECAAP_NON_PROD_ENDPOINT = 'https://ecaapxfac.fmr.com';
export const ECAAP_NON_PROD_EXTERNAL_ENDPOINT =
  'https://ecaapxfac.fidelity.com';
export const ECAAP_PROD_ENDPOINT = 'https://ecaap.fidelity.com';

// TODO: Remove once post-login logic is implemented in NextGen backend
export const SP_LOGIN_SCRIPT_PATH = '/fnx/_layouts/15/fnx/login.aspx';

// Security
export const SECURITY_AUTHENTICATE_PATH = `${FUNDSSERVICES_SECURITY_BASE_PATH}/authenticate`;

export const SECURITY_VALIDATE_SESSION_PATH = `${FUNDSSERVICES_SECURITY_BASE_PATH}/verifySession`;
